import { useEffect, useState } from "react";
import { api, fileUrl } from "@/lib/api";
import { Loader, EmptyState, Money } from "@/components/shared";
import { Button } from "@/components/ui/button";
import { FileText, FileDown } from "lucide-react";

export default function Invoices() {
  const [inv, setInv] = useState(null);
  useEffect(() => { api.get("/retailer/invoices").then((r) => setInv(r.data)).catch(() => setInv([])); }, []);
  if (!inv) return <Loader />;
  if (!inv.length) return <EmptyState title="No invoices yet" hint="Invoices are generated after successful payment." icon={FileText} />;
  return (
    <div className="space-y-4">
      <h1 className="font-heading text-2xl font-semibold text-forest">Invoices</h1>
      {inv.map((i) => (
        <div key={i.id} data-testid={`invoice-${i.id}`} className="flex items-center justify-between rounded-xl border border-border bg-card p-4">
          <div>
            <p className="num text-sm font-semibold text-forest">{i.invoice_number}</p>
            <p className="text-xs text-ink/50">{i.order_number} · {i.date.slice(0, 10)}</p>
          </div>
          <div className="flex items-center gap-3">
            <Money value={i.totals?.find((t) => t[0] === "Total")?.[1] || 0} className="text-forest" />
            <Button data-testid={`invoice-download-${i.id}`} size="sm" variant="outline" className="border-forest text-forest hover:bg-psage"
              onClick={() => window.open(fileUrl(`/api/invoices/${i.id}/pdf`) + `?t=${localStorage.getItem("script_token")}`, "_blank")}>
              <FileDown className="mr-1.5 h-3.5 w-3.5" /> PDF
            </Button>
          </div>
        </div>
      ))}
    </div>
  );
}
